import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import './index.css';
import './assets/fonts/satoshi/css/satoshi.css';
import './assets/fonts/pixel/pixel.css';
import 'react-datepicker/dist/react-datepicker.css';
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
